/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  CommunityDto,
  ContactDetailsCustomerAdditionalDetailsDto,
  ContactDetailsCustomerBillingDto,
  ContactDetailsCustomerCommonDto,
  ContactDetailsCustomerDto,
  ContactDetailsCustomerReferredByDto,
  ContactDetailsEmployeeCommonDto,
  ContactDetailsEmployeeDto,
  ContactDetailsEmployeeSalaryDto, EmployeePayBasis,
} from '@gh/builder-shared-data';
import {
  ContactDetailsEmployee,
  ContactDetailsEmployeeCommon,
  contactDetailsEmployeeCommonToDto
} from './contact-details-employee.model';
import { omit } from 'lodash';

export type ContactCommunity = CommunityDto;
export type ContactDetailsCustomer = ContactDetailsCustomerDto;
export type ContactDetailsCustomerCommon = ContactDetailsCustomerCommonDto;
export type ContactDetailsCustomerBilling = ContactDetailsCustomerBillingDto;
export type ContactDetailsCustomerReferredBy = ContactDetailsCustomerReferredByDto;
export type ContactDetailsCustomerAdditionalDetails = ContactDetailsCustomerAdditionalDetailsDto;

// tslint:disable-next-line:max-line-length
function contactDetailsCustomerAdditionalDetailsFromDto(dto: ContactDetailsCustomerAdditionalDetailsDto): ContactDetailsCustomerAdditionalDetails {
  const additionalDatesOfBirth = dto.additionalDatesOfBirth || { kids: [] };
  return {
    ...dto,
    additionalDatesOfBirth: {
      ...additionalDatesOfBirth,
      kids: additionalDatesOfBirth.kids.length > 0 ? additionalDatesOfBirth.kids : [{}],
    },
  };
}

export function contactDetailsCustomerToDto(model: ContactDetailsCustomer): ContactDetailsCustomerDto {
  return {
    ...<ContactDetailsCustomerDto>model,
    common: contactDetailsCustomerCommonToDto(model.common),
  };
}

function contactDetailsCustomerCommonFromDto(dto: ContactDetailsCustomerCommonDto): ContactDetailsCustomerCommon {
  return {
    ...dto,
    referredBy: {
      ...dto.referredBy,
      referredBy: dto.referredBy.referredBy ? {
        id: dto.referredBy.referredBy.itemCode,
        name: dto.referredBy.referredBy.localization,
      } : null,
    },
  };
}

export function contactDetailsCustomerFromDto(dto: ContactDetailsCustomerDto): ContactDetailsCustomer {
  return {
    ...dto,
    common: contactDetailsCustomerCommonFromDto(dto.common),
    additionalDetails: contactDetailsCustomerAdditionalDetailsFromDto(dto.additionalDetails),
  };
}

export function contactDetailsCustomerCommonToDto(model: ContactDetailsCustomerCommon): ContactDetailsCustomerCommonDto {
  return {
    ...model,
    referredBy: {
      ...model.referredBy,
      referredBy: {
        code: 'REFERRED_BY',
        itemCode: model.referredBy.referredBy.id,
        localization: model.referredBy.referredBy.name,
      },
    },
  };
}
